import React, { useState } from "react";
import PatientLoader from "../../../common/PatientLoader";
import OffCanvasComponent from "../../../common/offCanvas/OffCanvasComponent";
import InvitedWalkInOffCanvas from "../../dashboard/OffCanvas/InvitedWalkInOffCanvas";
import UpdatePatientBHINote from "../UpdatePatientBHINote";
import { Link } from "react-router-dom";
import { ReactComponent as SendMessage } from "../../../../assets/icons/Chat.svg";
import { ReactComponent as PinContent } from "../../../../assets/icons/PinContent.svg";
import { ReactComponent as DownloadProfile } from "../../../../assets/icons/DownloadProfile.svg";
import { ReactComponent as UpdateProfile } from "../../../../assets/icons/UpdateProfile.svg";
import RiskPill from "../../../common/RiskPill";
import PatientActionButton from "./PatientActionButton";
import PatientNotesCard from "./PatientNotesCard";
import { getInitials, notify } from "../../../../util/helpers";
import PatientProfileDownload from "./PatientProfileDownload";
import ProfilePDFModal from "./ProfilePDF";

const PatientIntroLayer = (props) => {
  const [walkinOffCanvasStatus, setWalkInOffCanvasStatus] = useState(false);
  const [notesOffCanvasStatus, setNotesOffCanvasStatus] = useState(false);
  const [updateMode, setUpdateMode] = useState(false);
  const [showDownloadPDF, setShowDownloadPDF] = useState(false);

  const fullName = `${props?.first_name} ${props.last_name}`;
  const initials = getInitials(fullName);
  return (
    <div className="container-fluid px-3 my-2">
      <ProfilePDFModal
        setIsOpen={setShowDownloadPDF}
        modalIsOpen={showDownloadPDF}
      />
      <OffCanvasComponent
        width={"35%"}
        modalIsOpen={notesOffCanvasStatus}
        setIsOpen={setNotesOffCanvasStatus}
      >
        {notesOffCanvasStatus && (
          <UpdatePatientBHINote
            closeModal={() => {
              setNotesOffCanvasStatus(false);
            }}
            isBHI={
              props?.patientData?.bhi_eligible && props?.patientData?.bhi_enabled
            }
          />
        )}
      </OffCanvasComponent>
      {/* <PatientProfileDownload
        modalIsOpen={showDownloadPDF}
        setModalOpen={setShowDownloadPDF}
      /> */}
      <OffCanvasComponent
        width={"35%"}
        modalIsOpen={walkinOffCanvasStatus}
        setIsOpen={setWalkInOffCanvasStatus}
      >
        {walkinOffCanvasStatus && (
          <InvitedWalkInOffCanvas
            closeModal={() => {
              setWalkInOffCanvasStatus(false);
            }}
            updateMode={updateMode}
          />
        )}
      </OffCanvasComponent>
      {props?.patientData ? (
        <div className="row container-fluid text-left mb-3">
          <div className=" col-sm-12 col-md-7 col-lg-7">
            <div className="container-fluid">
              <h4
                className="primary-text"
                style={{ textAlign: "start", textTransform: "capitalize" }}
              >
                {props.first_name}'s Profile
              </h4>
              <strong style={{ textTransform: "capitalize" }}>
                <Link to="/dashboard/home/">Dashboard</Link> /{" "}
                <Link to="/patients/">Patients</Link> / {fullName}
              </strong>
            </div>
            <div className="d-flex mt-2">
              <div>
                <img
                  height="125px"
                  width="125px"
                  alt="User's DP"
                  style={{ borderRadius: "100%", padding: "0.2rem" }}
                  src={
                    props?.profile_picture ||
                    `https://placehold.co/125x125/f1f1f5/395E9D/?text=${initials}`
                  }
                />
                <RiskPill type={props.flag} />
              </div>
              <div className="container-fluid">
                <div className="d-flex my-4" style={{ gap: "15px" }}>
                  <div>
                    <small
                      style={{
                        display: "block",
                        fontSize: "0.7rem",
                        fontWeight: "400",
                        letterSpacing: "2px",
                      }}
                    >
                      FIRST NAME
                    </small>
                    <h2
                      className="primary-text"
                      style={{ textTransform: "capitalize" }}
                    >
                      {props?.first_name}
                    </h2>
                  </div>
                  <div>
                    <small
                      style={{
                        display: "block",
                        fontSize: "0.7rem",
                        fontWeight: "400",
                        letterSpacing: "2px",
                      }}
                    >
                      LAST NAME
                    </small>
                    <h2
                      className="primary-text"
                      style={{ textTransform: "capitalize" }}
                    >
                      {props?.last_name}
                    </h2>
                  </div>
                </div>
                <div className="d-flex container-fluid" style={{ gap: "5px" }}>
                  {props?.rose_chat && (
                    <PatientActionButton
                      icon={<SendMessage width="14px" height="13px" />}
                      text={"Chat"}
                      callBack={() => {
                        props?.setIsChatExanpded(true);
                      }}
                    />
                  )}

                  <PatientActionButton
                    icon={<PinContent />}
                    text={"Pin Content"}
                    callBack={() => {
                      props?.setPinnedContentTab();
                    }}
                  />
                  {/* <PatientActionButton
                    icon={<DownloadProfile />}
                    text={"Download"}
                    callBack={() => {
                      props?.setDownloadMode(true);
                      // if (window.location.origin === "http://localhost:3000") {
                      //   //* Developer mode only
                      // } else {
                      //   notify("This feature is coming soon!", "info");
                      // }
                    }}
                  /> */}
                  {props?.patientData?.bhi_eligible &&
                  !props?.patientData?.bhi_enabled ? (
                    <PatientActionButton
                      styles={{ color: "#2D6A2B", backgroundColor: "#C3E9C4" }}
                      text={"+ Enroll"}
                      callBack={() => {
                        setWalkInOffCanvasStatus(true);
                      }}
                    />
                  ) : (
                    <></>
                  )}
                  {props?.patientData?.bhi_enabled && (
                    <PatientActionButton
                      icon={<UpdateProfile fill="#395e9d" />}
                      text={"Update BHI"}
                      callBack={() => {
                        setWalkInOffCanvasStatus(true);
                        setUpdateMode(true);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid col-sm-12 col-md-5 col-lg-5">
            <PatientNotesCard
              loading={props?.bhiLoading}
              setPatientNotesTab={props?.setPatientNotesTab}
              patientNotesLoading={props?.patientNotesLoading}
              patientNotesData={props?.patientNotes}
              setWalkInOffCanvasStatus={setNotesOffCanvasStatus}
              showUpdateButton={
                props?.patientData?.bhi_eligible &&
                props?.patientData?.bhi_enabled
              }
            />
          </div>
        </div>
      ) : (
        <PatientLoader />
      )}
    </div>
  );
};
export default PatientIntroLayer;
